export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Download.vue?vue&type=template&id=85f5b17a&"


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Download.vue?vue&type=template&id=85f5b17a&
// module id = null
// module chunks = 